<script setup>
import PageNotFound from '@/components/PageNotFound.vue';
import ToastHost from '@/components/base/ToastHost.vue';
</script>

<template>
  <PageNotFound />
  <ToastHost />
</template>
